import G6 from '@antv/g6';

const toolTip = new G6.Tooltip({
    // offsetX 与 offsetY 需要加上父容器的 padding
    offsetX: 22,
    offsetY: 22,
    // 允许出现 tooltip 的 item 类型
    itemTypes: ['node'],
    shouldBegin: e => {
        let itemData = e.item.getModel();
        let billno = itemData.billno;
        let userDefShowText = itemData.userDefShowText;
        if (billno?.indexOf('...') !== -1 || userDefShowText?.indexOf('...') !== -1) {
            return true
        } else {
            return false
        }

    },
    // 自定义 tooltip 内容
    getContent(e) {
        const outDiv = document.createElement('div');
        let itemData = e.item.getModel();
        //console.log("气泡获取值：e.item.getModel()", e.item.getModel())
        outDiv.style.maxWidth = '350px';
        let DivHtml = "<ul class='node-tooltip-ul'>" +
            "<li class='node-tooltip-li'>" + itemData.tooltipLabel + " : " + itemData.title + "</li>" +
            "<li class='node-tooltip-li'>" + itemData.label + " : " + itemData.billCode + "</li>";

        if (itemData.userDefShow && itemData.userDefName) {
            DivHtml = DivHtml +
                "<li class='node-tooltip-li'>" + itemData.userDefName + " : " + itemData.userDefShow + "</li>";
        }
        DivHtml = DivHtml + " </ul>";
        outDiv.innerHTML = DivHtml;
        return outDiv;
    },
});

// const miniMap = new G6.Minimap({
//     size: [130, 100],
//     className: "uap-minimap",
// });

const defaultEdge = {
    type: 'cubic-horizontal',
    style: {
        // radius: 20,
        offset: 35,
        endArrow: true,
        lineWidth: 1,
        stroke: '#999',
    },
}

// const defaultNode = {
//     type: 'rect',
//     size: [160, 80],
//     style: {
//         // fill: '#9EC9FF',
//         // stroke: '#5B8FF9',
//         lineWidth: 3,
//     },
//     labelCfg: {
//         style: {
//             fill: '#fff',
//             fontSize: 18,
//         },
//     },
//     linkPoints: {
//         top: false,
//         bottom: false,
//         left: true,
//         right: false,
//         size: 10,
//         fill: '#fff',
//         lineWidth: 1,
//         stroke: '#1890FF',
//     },
// };

export default {
    toolTip,
    // miniMap,
    defaultEdge,
    // defaultNode,
}